module.exports = __webpack_public_path__ + "img/Server-pana.69c2ab5a.png";